import { render } from "./PdfFieldEditor.vue?vue&type=template&id=3169755e&scoped=true&lang=pug"
import script from "./PdfFieldEditor.vue?vue&type=script&lang=js"
export * from "./PdfFieldEditor.vue?vue&type=script&lang=js"

import "./PdfFieldEditor.vue?vue&type=style&index=0&id=3169755e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3169755e"]])

export default __exports__